module.exports = __webpack_public_path__ + "img/no-picture.fd891b.svg";